export const  faceTipBoxZh = {
  notOneself1: '【系统提示】无法识别你的人脸，为避免误判，请保持人脸完整出现在摄像头范围内。',
  multiplayer1: '【系统提示】监测到考场内有其他人在场，为避免误判，请保持考场环境无干扰物。',
  noFace1: '【系统提示】无法识别你的人脸，为避免误判，请保持人脸完整出现在摄像头范围内。',
  notOneself: '[System notice] Face invisible. Please keep look ahead and show your whole face in the camera in case of system misjudgment.',
  multiplayer: "[System notice] Several faces in front of the camera. Please ensure you're ALONE in case of system misjudgment.",
  noFace: '[System notice] Face invisible. Please keep look ahead and show your whole face in the camera in case of system misjudgment.',
  Invigilator: '监考员',
  faceTipBoxSend: '发送',
  proctoringQRcode: 'https://img.webloom.cn/img/proctoringQRcodeZH.png',
  QRCodeHover: 'https://img.webloom.cn/img/QRCodeHoverZH.png',
  QRCodeActive: 'https://img.webloom.cn/img/QRCodeActiveZH.png',
  beginRadio: '监考员广播中，请留意手机。若无法听见，请尝试调高音量或告知监考员。',
  proctorTextRead: '如何重连手机监考二维码？'
}

export const  faceTipBoxEn = {
  notOneself1: '【系统提示】无法识别你的人脸，为避免误判，请保持人脸完整出现在摄像头范围内。',
  multiplayer1: '【系统提示】监测到考场内有其他人在场，为避免误判，请保持考场环境无干扰物。',
  noFace1: '【系统提示】无法识别你的人脸，为避免误判，请保持人脸完整出现在摄像头范围内。',
  notOneself: '[System notice] Face invisible. Please keep look ahead and show your whole face in the camera in case of system misjudgment.',
  multiplayer: "[System notice] Several faces in front of the camera. Please ensure you're ALONE in case of system misjudgment.",
  noFace: '[System notice] Face invisible. Please keep look ahead and show your whole face in the camera in case of system misjudgment.',
  Invigilator: 'Invigilator',
  faceTipBoxSend: 'send',
  proctoringQRcode: 'https://img.webloom.cn/img/proctoringQRcodeEN1.png',
  QRCodeHover: 'https://img.webloom.cn/img/QRCodeHoverEN1.png',
  QRCodeActive: 'https://img.webloom.cn/img/QRCodeActiveEN1.png',
  beginRadio: 'Invigilator broadcasting. Please pay attention to your phone. If you cannot hear, try to turn the volume up, or inform the invigilator.',
  proctorTextRead: 'How to reconnect to the mobile proctoring?'
}



// WEBPACK FOOTER //
// ./src/i18n/langs/proctor/faceTipBox.js